import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import LegalPage from "./pages/LegalPage";
import NotFoundPages from "./pages/NotFoundPages";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ProtectedRoute from "./components/ProtectedRoute";
import AdSysteme from "./pages/AdSysteme";
import Unauthorized from "./pages/Unauthorized";
// import CreaCompte from "./pages/CreaCompte";

const App = () => {
  return (
    <Router>
      <div className="container mx-auto p-4 bg-dotted min-h-screen">
        <Header />
        <Routes>
          <Route path="/:lang" element={<HomePage />} />
          <Route path="/:lang/login" element={<LoginPage />} />
          {/* <Route path="/:lang/crea" element={<CreaCompte />} /> */}
          <Route path="/:lang/legal-notices" element={<LegalPage />} />
          <Route path="/:lang/privacy-policy" element={<PrivacyPolicy />} />
          {/* Redirection racine */}
          <Route path="/" element={<Navigate to="/fr" replace />} />

          {/* Catch-all pour toutes les routes qui commencent par une langue inconnue */}
          <Route path="/:lang/*" element={<NotFoundPages />} />

          {/* Catch-all général pour toutes les autres routes */}
          <Route path="*" element={<Navigate to="/fr/not-found" replace />} />
          <Route path="*" element={<NotFoundPages />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/:lang/ad-systeme" element={<AdSysteme />} />
          </Route>
          <Route path="/:lang/unauthorized" element={<Unauthorized />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
